const Initreducer = (state, { type, payload }) => {
    switch (type) {
        case 'setclass':
            return { ...state, class: payload };
        default:
            return state;
    }
}

export default Initreducer;